export const CUSTOMER = 'customer';
export const APPLICANT = 'applicant';
export const AUTO_CUSTOMER = 'auto-customer';
export const AUTO_APPLICANT = 'auto-applicant';
export const AUTO_SYSTEM = 'auto-system';
